module.exports = __webpack_public_path__ + "assets/hcl-domino.93860937.svg";